<header class="topbar">
  <div class="container-fluid px-4">
    <div class="navbar-header">
      <div class="d-flex align-items-center gap-2">
        <div class="topbar-item">
          <button
            type="button"
            class="button-toggle-menu"
            (click)="toggleMobileMenu()"
          >
            <iconify-icon
              icon="iconamoon:menu-burger-horizontal"
              class="fs-22"
            ></iconify-icon>
          </button>
        </div>
      </div>

      <div class="d-flex align-items-center gap-1">
        <div class="topbar-item">
          <button
            type="button"
            class="topbar-button"
            id="light-dark-mode"
            (click)="changeTheme()"
          >
            <iconify-icon
              icon="iconamoon:mode-dark-duotone"
              class="fs-24 align-middle"
            ></iconify-icon>
          </button>
        </div>

        <div class="topbar-item">
          <button
            type="button"
            (click)="settingMenu()"
            class="topbar-button"
            id="theme-settings-btn"
            data-bs-target="#theme-settings-offcanvas"
            aria-controls="theme-settings-offcanvas"
          >
            <iconify-icon
              icon="iconamoon:settings-duotone"
              class="fs-24 align-middle"
            ></iconify-icon>
          </button>
        </div>

        <div ngbDropdown class="dropdown topbar-item">
          <a
            type="button"
            ngbDropdownToggle
            class="topbar-button arrow-none"
            id="page-header-user-dropdown"
            data-bs-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            <span class="d-flex align-items-center">
              <img
                class="rounded-circle"
                width="32"
                src="assets/images/users/avatar-1.jpg"
                alt="avatar-3"
              />
            </span>
          </a>
          <div ngbDropdownMenu class="dropdown-menu dropdown-menu-end">
            <!-- item-->
            <!-- <h6 class="dropdown-header">Welcome</h6> -->
            <a class="dropdown-item" routerLink="/user/profile">
              <i
                class="bx bx-user-circle text-muted fs-18 align-middle me-1"
              ></i
              ><span class="align-middle">Profile</span>
            </a>
            <a class="dropdown-item" routerLink="/user/packages">
              <i class="bx bx-package text-muted fs-18 align-middle me-1"></i>
              <span class="align-middle">Packages</span>
            </a>
            <!-- <a class="dropdown-item" routerLink="/apps/chat">
              <i
                class="bx bx-message-dots text-muted fs-18 align-middle me-1"
              ></i
              ><span class="align-middle">Messages</span>
            </a> -->

            <!-- <a class="dropdown-item" routerLink="/pages/pricing">
              <i class="bx bx-wallet text-muted fs-18 align-middle me-1"></i
              ><span class="align-middle">Pricing</span>
            </a> -->
            <!-- <a class="dropdown-item" routerLink="/pages/faqs">
              <i
                class="bx bx-help-circle text-muted fs-18 align-middle me-1"
              ></i
              ><span class="align-middle">Help</span>
            </a> -->
            <!-- <a class="dropdown-item" routerLink="/auth/lock-screen">
              <i class="bx bx-lock text-muted fs-18 align-middle me-1"></i
              ><span class="align-middle">Lock screen</span>
            </a> -->

            <div class="dropdown-divider my-1"></div>

            <a class="dropdown-item text-danger" (click)="logout()">
              <i class="bx bx-log-out fs-18 align-middle me-1"></i
              ><span class="align-middle">Logout</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</header>
